<script setup lang="ts">
withDefaults(
  defineProps<{ tone?: 'neutral' | 'accent' | 'success' | 'warning' | 'danger' }>(),
  { tone: 'neutral' },
)
</script>

<template>
  <span class="badge" :class="tone"><slot /></span>
</template>

<style scoped>
.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.15em var(--space-2xs);
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  line-height: 1.5;
  letter-spacing: var(--tracking-wide);
  white-space: nowrap;
  border-radius: var(--radius-full);
}

.neutral {
  color: var(--color-text-muted);
  background-color: var(--color-surface-sunken);
}

.accent {
  color: var(--color-accent-hover);
  background-color: var(--color-accent-soft);
}

.success {
  color: var(--color-success);
  background-color: color-mix(in srgb, var(--color-success) 12%, transparent);
}

.warning {
  color: var(--color-accent-2);
  background-color: var(--color-accent-2-soft);
}

.danger {
  color: var(--color-danger);
  background-color: var(--color-danger-soft);
}
</style>
